import React, {useCallback} from 'react'
import styles from './BackButton.module.css'
import { BackButtonProps } from './types'
import { useStepContext } from '@/components/Context/StepContext'

export const BackButton: React.FC<BackButtonProps> = ({
    dataClickLabel,
    onClick
}) => {
    const { handlePrev } = useStepContext()

    const handleClick = useCallback(() => {
        if (onClick) {
            onClick()
        } else {
            handlePrev()
        }
    }, [onClick, handlePrev])

    return (
        <button
            className={styles.content}
            onClick={handleClick}
            data-click-label={dataClickLabel}
            type='button'
        >
            <img
                src={'/entry_form_slide_app/common/previewIcon.png'}
                alt={'バックボタンアイコン'}
            />
        </button>
    )
}
